import React from "react";
import { useTranslation, Trans } from "react-i18next";
import VideoCarousel from "./VideoCarousel";

export default function AboutUs() {
  const { t } = useTranslation();
  const sampleVideos = [
    {
      src: "https://youtu.be/ZP-P_ASQQco",
      title: t('about.section3Video1'),
      description: t('about.section3Desc1'),
    },
    {
      src: "https://youtu.be/pDwLj6sSlAw",
      title: t('about.section3Video2'),
      description: t('about.section3Desc2'),
    },
    {
      src: "https://youtu.be/8QlT2g8ET3Q",
      title: t('about.section3Video3'),
      description: t('about.section3Desc3'),
    }
  ];

  return (
    <div>
      <h1 className="text-4xl font-bold mb-6 font-serif">{t('about.title')}</h1>

      <div className="prose dark:prose-invert space-y-8">
        <section className="bg-raya-section p-8 rounded-lg shadow-md border-t-8 border-raya-accent">
          <h2 className="text-3xl font-serif font-bold mb-4 text-raya-accent">{t('about.section1Title')}</h2>
          <p className="text-raya-text-primary/90 mb-4 leading-relaxed text-lg">
            {t('about.section1Text1')}
          </p>
          <p className="text-raya-text-primary/90 leading-relaxed text-lg">
            <Trans i18nKey="about.section1Text2">
              We are dedicated to preserving and sharing the breathtaking beauty of the <strong>Raya Kemis</strong> 
              and the rich traditions it represents.
            </Trans>
          </p>
        </section>

        <section className="py-20 bg-raya-card border-y border-raya-border">
          <h2 className="text-3xl font-serif font-bold mb-6 text-raya-accent text-center">
            {t('about.servicesTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Traditional Attire */}
            <div className="flex flex-col items-center text-center p-4 bg-raya-card rounded-lg transition-transform hover:scale-105 border border-raya-border">
              <span className="text-4xl mb-3">👗</span>
              <h3 className="text-xl font-bold mb-2 text-raya-text-primary">{t('about.service1Title')}</h3>
              <p className="text-raya-text-primary/90">{t('about.service1Text')}</p>
            </div>
            
            {/* Accessories */}
            <div className="flex flex-col items-center text-center p-4 bg-raya-card rounded-lg transition-transform hover:scale-105 border border-raya-border">
              <span className="text-4xl mb-3">💍</span>
              <h3 className="text-xl font-bold mb-2 text-raya-text-primary">{t('about.service2Title')}</h3>
              <p className="text-raya-text-primary/90">{t('about.service2Text')}</p>
            </div>

            {/* Spices */}
            <div className="flex flex-col items-center text-center p-4 bg-raya-card rounded-lg transition-transform hover:scale-105 border border-raya-border">
              <span className="text-4xl mb-3">🌶️</span>
              <h3 className="text-xl font-bold mb-2 text-raya-text-primary">{t('about.service3Title')}</h3>
              <p className="text-raya-text-primary/90">{t('about.service3Text')}</p>
            </div>

            {/* Catering */}
            <div className="flex flex-col items-center text-center p-4 bg-raya-card rounded-lg transition-transform hover:scale-105 border border-raya-border">
              <span className="text-4xl mb-3">🍽️</span>
              <h3 className="text-xl font-bold mb-2 text-raya-text-primary">{t('about.service4Title')}</h3>
              <p className="text-raya-text-primary/90">{t('about.service4Text')}</p>
            </div>
          </div>
        </section>

        <section className="bg-raya-section p-8 rounded-lg shadow-md border-t-8 border-raya-border">
          <h2 className="text-3xl font-serif font-bold mb-4 text-raya-text-primary">{t('about.section2Title')}</h2>
          <p className="text-raya-text-primary/90 mb-4 leading-relaxed text-lg">
            <Trans i18nKey="about.section2Text">
              The traditional dress of Raya women is a masterpiece of textile art. Known for its 
              distinctive two-piece design, it typically features a luxurious white cotton base 
              elaborately adorned with <em>tibebe</em> (embroidery).
            </Trans>
          </p>
          <ul className="space-y-4 text-raya-text-primary/90 text-lg">
            <li className="flex items-start">
              <span className="text-2xl mr-3">🎨</span>
              <span>
                <strong>{t('about.paletteTitle')}</strong> {t('about.paletteText')}
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-2xl mr-3">🧵</span>
              <span>
                <strong>{t('about.embroideryTitle')}</strong> {t('about.embroideryText')}
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-2xl mr-3">🎉</span>
              <span>
                <strong>{t('about.significanceTitle')}</strong> 
                <Trans i18nKey="about.significanceText">
                  Worn during weddings (<em>Mellqez</em>), religious festivals like <em>Timket</em>, 
                  and community gatherings, the dress is a symbol of pride, elegance, and identity.
                </Trans>
              </span>
            </li>
          </ul>
        </section>

        <section className="bg-raya-section p-8 rounded-lg shadow-md border-t-8 border-raya-accent">
          <h2 className="text-3xl font-serif font-bold mb-4 text-raya-accent">{t('about.section3Title')}</h2>
          <p className="text-raya-text-primary/90 mb-6 leading-relaxed text-lg">
            {t('about.section3Text')}
          </p>
          <VideoCarousel videos={sampleVideos} />
        </section>

        <section className="bg-raya-section p-8 rounded-lg shadow-md border-t-8 border-raya-accent">
          <h2 className="text-3xl font-serif font-bold mb-4 text-raya-accent">{t('about.missionTitle')}</h2>
          <p className="text-raya-text-primary/90 leading-relaxed text-lg">
            {t('about.missionText')}
          </p>
        </section>
      </div>
    </div>
  );
}
